import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { JobLogViewer } from '@/components/jobs/JobLogViewer';
import { ws } from '@/lib/ws';
import type { JobMeta } from '@shared/protocol';

export function JobDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [job, setJob] = useState<JobMeta | null>(null);
  const [lines, setLines] = useState<string[]>([]);

  useEffect(() => {
    if (!id) return;
    const offLog = ws.on('job.log', (msg) => {
      if (msg.job_id === id) setLines((prev) => [...prev, msg.line]);
    });
    const offStatus = ws.on('job.status', (msg) => {
      if (msg.job_id === id) setJob((j) => (j ? { ...j, status: msg.status } : j));
    });
    ws.send({ type: 'jobs.subscribe', job_id: id });
    return () => {
      offLog();
      offStatus();
      ws.send({ type: 'jobs.unsubscribe', job_id: id });
    };
  }, [id]);

  return (
    <div className="max-w-5xl space-y-4">
      <div className="flex items-center gap-4">
        <Link to="/jobs" className="text-sm underline text-muted-foreground">
          ← Jobs
        </Link>
        <h1 className="text-2xl font-semibold">Job {id}</h1>
        {job && <Badge>{job.status}</Badge>}
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Live log</CardTitle>
        </CardHeader>
        <CardContent>
          <JobLogViewer lines={lines} />
        </CardContent>
      </Card>
    </div>
  );
}
